/* unplugin-vue-components disabled */import { render } from "./BaseImageFallback.vue?vue&type=template&id=5f6fd830"
import script from "./BaseImageFallback.vue?vue&type=script&lang=js"
export * from "./BaseImageFallback.vue?vue&type=script&lang=js"

import "./BaseImageFallback.vue?vue&type=style&index=0&id=5f6fd830&lang=scss"
script.render = render

export default script